import {inject, Injectable} from '@angular/core';
import {catchError, debounceTime, finalize, map, Observable, tap, throwError} from 'rxjs';
import {LoadingService, LoadingStates} from './loading.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';

export interface IConfigPagination {
  itemsPerPage: number,
  currentPage: number,
  totalItems: any
}

export interface IImgUrls {
  orig: string;
  blurHash: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  loadingService = inject(LoadingService);
  http = inject(HttpClient)
  headers = new HttpHeaders();
  ServerURL = environment.apiUrl;

  constructor() {
  }

  RequestHandler(
    runRequest: () => Observable<any>,
    RequestType = LoadingStates.UNKNOWN
  ): Observable<any> {
    let loadingId = this.loadingService.startLoading(RequestType);

    return runRequest().pipe(
      debounceTime(50),
      finalize(() => this.loadingService.finishLoading(loadingId)),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  SendPost(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.post(ServerURL + method, data,);
    }, type);
  }

  SendPatch(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.patch(ServerURL + method, data,);
    }, type);
  }

  SendPut(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.put(ServerURL + method, data,);
    }, type);
  }

  SendGet(method: string, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.get(ServerURL + method,);
    }, type);
  }

  SendGetBlobImg(method: string, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.get(ServerURL + method, {
        headers: this.headers,
        responseType: "blob" as "json",
        observe: "response",
      }).pipe(map(this.getResponse2File));
    }, type);
  }

  getResponse2File = (response: any) => {
    const type = response.headers.get("Content-Type");
    const blob = new Blob([response.body], {type});
    return URL.createObjectURL(blob);
  };

  SendDelete(method: string, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.delete(ServerURL + method,);
    }, type);
  }

  SendPostWithProgress(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.post(ServerURL + method, data, {
        reportProgress: true,
        observe: 'events'
      });
    }, type);
  }
}
